module.exports = __webpack_public_path__ + "static/media/test16_3.c35887eb.png";